export default {
  getDateFormYYYYMMDD (date) {
    const dateObj = (date) ? new Date(date) : new Date()
    var m = '' + (dateObj.getMonth() + 1)
    var d = '' + dateObj.getDate()
    var y = dateObj.getFullYear()
    var dateArray = []
    if (m.length < 2) {
      m = '0' + m
    }
    if (d.length < 2) {
      d = '0' + d
    }
    dateArray.push(y)
    dateArray.push(m)
    dateArray.push(d)

    return dateArray.join('-')
  },
  getAfterNDaysFromYYYYMMDD (date, day) {
    var dateObj = (date) ? new Date(date) : new Date()
    var m
    var d
    var y
    var dateArray = []
    dateObj.setDate(dateObj.getDate() + day)
    m = '' + (dateObj.getMonth() + 1)
    d = '' + dateObj.getDate()
    y = dateObj.getFullYear()
    if (m.length < 2) {
      m = '0' + m
    }
    if (d.length < 2) {
      d = '0' + d
    }
    dateArray.push(y)
    dateArray.push(m)
    dateArray.push(d)

    return dateArray.join('-')
  },
  encodeString (string) {
    var finalVal
    if (string) {
      finalVal = encodeURIComponent(string)
    }
    return finalVal
  },
  decodeString (string) {
    var finalVal
    if (string) {
      finalVal = decodeURIComponent(string)
    }
    return finalVal
  }
}
